import { render, staticRenderFns } from "./FloatingPage.vue?vue&type=template&id=ba066596&scoped=true&"
import script from "./FloatingPage.vue?vue&type=script&lang=js&"
export * from "./FloatingPage.vue?vue&type=script&lang=js&"
import style0 from "./FloatingPage.vue?vue&type=style&index=0&id=ba066596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba066596",
  null
  
)

export default component.exports